import React from "react";
import {
  Box,
  Skeleton,
  Paper,
  Grid,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import OuterDiv from "components/Common/OuterDivComponent";

const theme = createTheme({
  palette: {
    background: {
      default: "#f5f5f5",
    },
  },
});

const CampaignDetailsSkeleton = () => {
  return (
    <OuterDiv>
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            padding: "10px 15px",
            background: "#F8FAFF",
            minHeight: "100vh",
          }}
        >
          <Box
            sx={{
              display: "flex",
              padding: "16px 30px",
              borderRadius: 2,
              border: "1px solid #e0e0e0",
              mb: 2,
              width: "100%",
              background: "#fff",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Box sx={{ mr: 2 }}>
                <Skeleton
                  variant="rectangular"
                  width={40}
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
              <Box sx={{ width: "20%" }}>
                <Skeleton variant="text" width="80%" height={28} />
                <Skeleton
                  variant="rectangular"
                  width="60%"
                  height={4}
                  sx={{ mt: 1 }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  ml: "auto",
                  gap: 3,
                  alignItems: "center",
                }}
              >
                <Box sx={{ textAlign: "center", width: 60 }}>
                  <Skeleton variant="text" width="100%" height={28} />
                  <Skeleton variant="text" width="100%" height={14} />
                </Box>
                <Skeleton variant="rectangular" width={1} height={40} />
                <Box sx={{ textAlign: "center", width: 60 }}>
                  <Skeleton variant="text" width="100%" height={28} />
                  <Skeleton variant="text" width="100%" height={14} />
                </Box>
                <Skeleton variant="rectangular" width={1} height={40} />
                <Box sx={{ textAlign: "center", width: 60 }}>
                  <Skeleton variant="text" width="100%" height={28} />
                  <Skeleton variant="text" width="100%" height={14} />
                </Box>
                <Skeleton variant="rectangular" width={1} height={40} />
                <Box sx={{ textAlign: "center", width: 100 }}>
                  <Skeleton variant="text" width="100%" height={28} />
                  <Skeleton variant="text" width="100%" height={14} />
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              padding: "10px 15px",
              bgcolor: "#fff",
              border: "1px solid #DCDFE5",
              borderRadius: "8px",
              marginTop: "20px",
            }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
            >
              <Box sx={{ display: "flex", gap: 2 }}>
                {[1, 2, 3, 4, 5].map((item) => (
                  <Skeleton
                    key={item}
                    variant="rectangular"
                    width={100}
                    height={32}
                    sx={{ borderRadius: 1 }}
                  />
                ))}
              </Box>
              <Skeleton
                variant="rectangular"
                width={200}
                height={32}
                sx={{ borderRadius: 1 }}
              />
            </Box>

            <Box sx={{ display: "flex", gap: 4, px: 2, py: 3 }}>
              {[1, 2, 3, 4, 5, 6].map((item) => (
                <Skeleton
                  key={item}
                  variant="rectangular"
                  width="15%"
                  height={110}
                  sx={{ borderRadius: 2, minWidth: 140 }}
                />
              ))}
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
            >
              <Skeleton
                variant="rectangular"
                width={250}
                height={40}
                sx={{ borderRadius: 1 }}
              />
              <Box sx={{ display: "flex", gap: 1 }}>
                <Skeleton
                  variant="rectangular"
                  width={120}
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={120}
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={120}
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={40}
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
            </Box>

            <Paper elevation={0} sx={{ border: "1px solid #EAECF0", mb: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  p: 2,
                  borderBottom: "1px solid #EAECF0",
                  background: "#f8f9fa",
                }}
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
                  <Skeleton
                    key={item}
                    variant="text"
                    width={item === 1 ? "5%" : "10%"}
                    height={24}
                    sx={{ mx: 1 }}
                  />
                ))}
              </Box>

              {[1, 2, 3, 4, 5, 6, 7, 8].map((row) => (
                <Box
                  key={row}
                  sx={{
                    display: "flex",
                    p: 2,
                    borderBottom: "1px solid #EAECF0",
                    background: row % 2 === 0 ? "#ffffff" : "#F9FAFB",
                  }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((col) => (
                    <Skeleton
                      key={`${row}-${col}`}
                      variant={col === 3 ? "rectangular" : "text"}
                      width={col === 1 ? "5%" : "10%"}
                      height={col === 3 ? 22 : 24}
                      sx={{ mx: 1, borderRadius: col === 3 ? 4 : 0 }}
                    />
                  ))}
                </Box>
              ))}

              <Box
                sx={{ display: "flex", justifyContent: "space-between", p: 2 }}
              >
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Skeleton
                    variant="rectangular"
                    width={80}
                    height={32}
                    sx={{ borderRadius: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={80}
                    height={32}
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
                <Skeleton variant="text" width={60} height={32} />
              </Box>
            </Paper>
          </Box>
        </Box>
      </ThemeProvider>
    </OuterDiv>
  );
};

export default CampaignDetailsSkeleton;
